import React, { ComponentType } from 'react';
import MultiGradientThemeIcon from '../multi-gradient-theme-icon';
import { SvgIconProps } from '@fx-ui/icon';

interface ThemedStateIconProps extends Omit<SvgIconProps, 'component'> {
    active?: boolean;
    icon?: ComponentType<SvgIconProps>;
    activeIcon?: ComponentType<SvgIconProps>;
}

const ThemedStateIcon: React.FC<ThemedStateIconProps> = ({
    active,
    icon,
    activeIcon,
    ...restProps
}) => {
    if (!icon) {
        return null;
    }
    const targetIcon = active ? activeIcon ?? icon : icon;
    return <MultiGradientThemeIcon icon={targetIcon} {...restProps} />;
};

export default ThemedStateIcon;
